import {Injectable} from '@angular/core';
import {VexLayoutService} from '@vex/services/vex-layout.service';
import {NavigationItem} from './navigation-item.interface';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService) {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'subheading',
        label: 'Dashboard',
        availableTo: ['USER'],
        children: [
          {
            type: 'link',
            label: 'Home',
            route: '/home',
            icon: 'mat:home',
            routerLinkActiveOptions: {exact: true},
            availableTo: ['USER'],
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Meetings',
        availableTo: ['USER'],
        children: [
          {
            type: 'link',
            label: 'List',
            route: '/meeting',
            icon: 'mat:group',
            routerLinkActiveOptions: {exact: true},
            availableTo: ['USER'],
          }
        ]
      },
    ]);
  }
}
